'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.achievementsPastReservationsCount = exports.achievementsPastReservations = undefined;

var _sagaTools = require('@classpass/saga-tools');

var achievementsPastReservations = exports.achievementsPastReservations = (0, _sagaTools.makeEntityScaffold)('SAGA.API.ACHIEVEMENTS_PAST_RESERVATIONS', function (client) {
  return client.achievements.pastReservations().then(function (data) {
    return data;
  });
});

var achievementsPastReservationsCount = exports.achievementsPastReservationsCount = (0, _sagaTools.makeEntityScaffold)('SAGA.API.ACHIEVEMENTS_PAST_RESERVATIONS_COUNT', function (client) {
  return client.achievements.pastReservationsMeta().then(function (data) {
    return data;
  });
});